import { render, staticRenderFns } from "./BalanceDetails.vue?vue&type=template&id=08c07f49&scoped=true&"
import script from "./BalanceDetails.vue?vue&type=script&lang=js&"
export * from "./BalanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDetails.vue?vue&type=style&index=0&id=08c07f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c07f49",
  null
  
)

export default component.exports